import type { SplitTestConfig } from '../../splitTestTypes';
import { getSeasonPassConfigs } from '../../../../gameEvents/seasonPass/seasonPassConfig';
import { hs774lessGenerousConfig } from './HS774lessGenerous';
import { hs774generousConfig } from './HS774generous';

let hs774Distribution: number | null = null;

export function hs774isSeasonPassActive(): boolean {
  return hs774Distribution !== null && hs774Distribution > 1;
}

export function getHS774Distribution(): number | null {
  return hs774Distribution;
}

export const hs774seasonPass: SplitTestConfig = {
  distributions: 5,
  returningUserTestSlug: 'SeasonPass_RU_HS774',
  newUserTestSlug: null,
  onActive(app, distribution) {
    hs774Distribution = distribution;

    if (distribution === 1) return;

    if (distribution === 2 || distribution === 3) {
      app.utils.variableBank.setTextVariable('seasonPass.valueBadgeAmount', distribution === 2 ? '300%' : '400%');
      getSeasonPassConfigs().push(hs774lessGenerousConfig);
    }

    if (distribution === 4 || distribution === 5) {
      app.utils.variableBank.setTextVariable('seasonPass.valueBadgeAmount', distribution === 4 ? '500%' : '800%');
      getSeasonPassConfigs().push(hs774generousConfig);
    }
  },
};
